<div class="range-filter">
  <span class="range-filter__label">{{ label }}</span>
  <div class="range-filter__fields">
    <input
      class="range-filter__input"
      type="number"
      inputmode="numeric"
      [attr.min]="min"
      [attr.max]="max"
      [placeholder]="fromLabel"
      [attr.aria-label]="label + ' ' + fromLabel"
      [value]="from ?? ''"
      (input)="onFromChange($any($event.target).value)"
    />
    <span class="range-filter__separator">&ndash;</span>
    <input
      class="range-filter__input"
      type="number"
      inputmode="numeric"
      [attr.min]="min"
      [attr.max]="max"
      [placeholder]="toLabel"
      [attr.aria-label]="label + ' ' + toLabel"
      [value]="to ?? ''"
      (input)="onToChange($any($event.target).value)"
    />
  </div>
</div>
